import { Basket } from '@/components/templates/Basket/Basket'

export default Basket
